export interface SearchableListModel {
  label: string;
  value: string;
  hideFilterBar?: boolean;
  filterBy?: string;
  allowMultipleSelection?: boolean;
}
